import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col items-center pt-8" }
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}
const _hoisted_3 = { class: "fixed bottom-0 left-0 right-0 bg-white z-50 rounded-t-[2.5rem] shadow-2xl flex flex-col max-h-[60vh] lg:hidden" }
const _hoisted_4 = { class: "p-4 flex flex-col items-center border-b border-gray-50" }
const _hoisted_5 = { class: "w-full overflow-x-auto no-scrollbar pb-2" }
const _hoisted_6 = { class: "flex gap-4 px-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "overflow-y-auto grow p-2" }
const _hoisted_9 = { class: "p-6 border-t border-gray-100 flex flex-col items-center gap-4 bg-gray-50/50" }
const _hoisted_10 = { class: "relative w-full flex justify-center p-4 lg:p-0 top-0 h-full" }
const _hoisted_11 = {
  key: 0,
  class: "md:w-1/3 px-8 sticky top-8 h-fit"
}
const _hoisted_12 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_13 = { class: "text-xl font-serif text-gray-800 tracking-widest uppercase" }

import {computed, reactive, onMounted, onUnmounted, ref, watch} from "vue";
import { useI18n } from "vue-i18n";
import DiamondNav from "@/components/diamonds/DiamondNav.vue";
import DiamondsSearchResult from "@/components/diamonds/diamondsSearchResult.vue";
import DiamondsSearchForm from "@/components/diamonds/diamondsSearchForm.vue";
import { presets } from "@/assets/ts/diamondFilters";
import DiamondsMobileSearchForm from "@/components/diamonds/form/diamondsMobileSearchForm.vue";
import {Config} from "@/assets/ts/config";
import {SetWidget} from "@/assets/ts/stepWidget";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearch',
  props: {
  certificatedDiamond: {
    type: Object,
    default: null
  }
},
  setup(__props) {


const { t } = useI18n();
const isMobile = ref(false);
const showMobileFilters = ref(false);
const searchMode = ref<'simple' | 'pro'>('pro');
const setWidgetApi = new SetWidget();

const props = __props;

const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024; // Using 1024px as breakpoint for "small table" (tablet)
  if (!isMobile.value) {
    showMobileFilters.value = false;
  }
};

const toggleMobileFilters = () => {
  showMobileFilters.value = !showMobileFilters.value;
  if (showMobileFilters.value) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};

const sortedFilterKeys = computed(() => {
  const simpleKeys = ['type', 'size', 'form'];
  return Object.keys(filters)
    .filter(key => {
      if (key === 'sortOrder') return false;
      if (key === 'fancy_intensity' && !activeFilters.colored) return false;
      if (searchMode.value === 'simple' && !simpleKeys.includes(key)) return false;
      return true;
    })
    .sort((a, b) => {
      return (filters[a].order || 0) - (filters[b].order || 0);
    });
});

const host = process.env.VUE_APP_HOST || "";

const filters = reactive({
  type: {
    order: 1,
    type: "text",
    view: "switch",
    visible: false,
    default: "earth",
    modalId: "stoneType",
    values: {
      earth: t('components.diamonds.search.type.earth'),
      lab: t('components.diamonds.search.type.lab')
    }
  },
  form: {
    order: 2,
    type: "icon",
    view: "list",
    visible: true,
    default: "BR",
    modalId: "stoneForm",
    image: host + "/img/diamonds/filter/form/{value}@2x.png",
    values: {
      BR: t('components.diamonds.search.form.BR'),
      OV: t('components.diamonds.search.form.OV'),
      EM: t('components.diamonds.search.form.EM'),
      PE: t('components.diamonds.search.form.PE'),
      PR: t('components.diamonds.search.form.PR'),
      RA: t('components.diamonds.search.form.RA'),
      HE: t('components.diamonds.search.form.HE'),
      MA: t('components.diamonds.search.form.MA'),
      CU: t('components.diamonds.search.form.CU'),
    },
  },
  size: {
    order: 3,
    type: "number",
    view: "range",
    visible: true,
    unit: "ct.",
    modalId: "stoneSize",
    default: {
      min: 0.3,
      max: 10,
    },
    "min": 0.3,
    "max": 10
  },
  color: {
    order: 6,
    type: "icon",
    view: "range",
    visible: false,
    modalId: "stoneColor",
    image: host + "/img/diamonds/details/color_{value}.webp",
    lowercaseImage: true,
    default: ["G", "F", "E", "D"],
    values: {
      J: "J",
      I: "I",
      H: "H",
      G: "G",
      F: "F",
      E: "E",
      D: "D",
    },
    fancy_colors: {
      // RED: "RED",
      // BROWN: "BROWN",
      // BLACK: "BLACK",
      // ORANGE: "ORANGE",
      YELLOW: t('components.diamonds.search.color.YELLOW'),
      PINK: t('components.diamonds.search.color.PINK'),
      BLUE: t('components.diamonds.search.color.BLUE'),
      GREEN: t('components.diamonds.search.color.GREEN'),
    },
  },
  fancy_intensity: {
    order: 7,
    type: "text",
    view: "range",
    modalId: "stoneFancyIntensity",
    visible: false,
    default: [],
    values: {
      LIGHT: t('components.diamonds.search.fancy_intensity.LIGHT'),
      FANCY: t('components.diamonds.search.fancy_intensity.FANCY'),
      INTENSE: t('components.diamonds.search.fancy_intensity.INTENSE'),
      VIVID: t('components.diamonds.search.fancy_intensity.VIVID'),
      DEEP: t('components.diamonds.search.fancy_intensity.DEEP'),
    },
  },
  colored: {
    order: 5,
    type: "bool",
    view: "switch",
    modalId: "stoneColored",
    visible: false,
    default: false,
    values: {
      false: t('components.diamonds.search.colored.false'),
      true: t('components.diamonds.search.colored.true')
    }
  },
  clarity: {
    order: 8,
    type: "icon",
    view: "range",
    visible: false,
    modalId: "stoneClarity",
    image: host + "/img/diamonds/filter/clarity/{value}@2x.jpg",
    lowercaseImage: false,
    default: [],
    values: {
      SI2: "SI2",
      SI1: "SI1",
      VS2: "VS2",
      VS1: "VS1",
      VVS2: "VVS2",
      VVS1: "VVS1",
      IF: "IF",
      FL: "FL",
    },
  },
  cut: {
    order: 9,
    type: "icon",
    view: "range",
    modalId: "stoneCut",
    visible: false,
    default: ["EX", "ID"],
    image: host + "/img/diamonds/details/cut_{value}.webp",
    lowercaseImage: true,
    values: {
      GD: t('components.diamonds.search.cut.GD'),
      VG: t('components.diamonds.search.cut.VG'),
      EX: t('components.diamonds.search.cut.EX'),
      ID: t('components.diamonds.search.cut.ID'),
    },
  },
  polish: {
    order: 10,
    type: "text",
    view: "range",
    modalId: "stonePolish",
    visible: false,
    default: ["EX"],
    values: {
      GD: t('components.diamonds.search.polish.GD'),
      VG: t('components.diamonds.search.polish.VG'),
      EX: t('components.diamonds.search.polish.EX'),
      /*ID: "Ideal",*/
    },
  },
  symmetry: {
    order: 11,
    type: "text",
    view: "range",
    modalId: "stoneSymmetry",
    visible: false,
    default: ["EX"],
    values: {
      GD: t('components.diamonds.search.symmetry.GD'),
      VG: t('components.diamonds.search.symmetry.VG'),
      EX: t('components.diamonds.search.symmetry.EX'),
    },
  },
  fluorescence: {
    order: 12,
    type: "icon",
    image: host + "/img/diamonds/filter/fluorescence/fluo_{value}@2x.jpg",
    view: "range",
    modalId: "stoneFluorescence",
    visible: false,
    default: ["N"],
    values: {
      /*VS: "Very Strong",*/
      /*S: "Strong",*/
      /*M: "Medium",*/
      /*F: "Faint",*/
      SL: t('components.diamonds.search.fluorescence.SL') /* Nutzt im Backend auch Faint */,
      VSL: t('components.diamonds.search.fluorescence.VSL'),
      N: t('components.diamonds.search.fluorescence.N'),
    },
  },
  institute: {
    order: 13,
    type:"text",
    view:"list",
    modalId: "stoneInstitute",
    visible: false,
    image: host + "/img/diamonds/filter/institute/{value}.svg",
    default: ["GIA"],
    values: {
      GIA: "GIA",
      HRD: "HRD",
      IGI: "IGI",
    },
  },
  fastDelivery: {
    order: 14,
    type: "text",
    view: "switch",
    modalId: "fastDelivery",
    visible: false,
    default: false,
    values: {
      false: t('components.diamonds.search.fastDelivery.false'),
      true: t('components.diamonds.search.fastDelivery.true')
    }
  },
  price: {
    order: 4,
    type: "number",
    view: "range",
    visible: true,
    min: 0,
    max: 5000000,
    unit: "€",
    default: {
      min: 0,
      max: 5000000
    }
  },
  sortOrder: {
    default: "asc"
  }
});

const formMap: Record<string, string> = {
  'ROUND': 'BR',
  'OVAL': 'OV',
  'EMERALD': 'EM',
  'PEAR': 'PE',
  'PRINCESS': 'PR',
  'RADIANT': 'RA',
  'HEART': 'HE',
  'MARQUISE': 'MA',
  'CUSHION': 'CU'
};

const DEFAULT_FORM_VALUES = {
  BR: t('components.diamonds.search.form.BR'),
  OV: t('components.diamonds.search.form.OV'),
  EM: t('components.diamonds.search.form.EM'),
  PE: t('components.diamonds.search.form.PE'),
  PR: t('components.diamonds.search.form.PR'),
  RA: t('components.diamonds.search.form.RA'),
  HE: t('components.diamonds.search.form.HE'),
  MA: t('components.diamonds.search.form.MA'),
  CU: t('components.diamonds.search.form.CU'),
};

const DEFAULT_CUT_VALUES = {
  GD: t('components.diamonds.search.cut.GD'),
  VG: t('components.diamonds.search.cut.VG'),
  EX: t('components.diamonds.search.cut.EX'),
  ID: t('components.diamonds.search.cut.ID'),
};

const activeFilters = reactive({});

// Initialize active filters with default values
Object.keys(filters).forEach((key) => {
  activeFilters[key] = filters[key].default || null;
});

watch([() => activeFilters.type, () => activeFilters.cut], ([newType, newCut]) => {
  if (newType === 'earth') {
    // Reduce cut options: remove "ID" for earth diamonds
    const { ID, ...reducedCutValues } = DEFAULT_CUT_VALUES;
    filters.cut.values = reducedCutValues;

    // If ID is currently selected, remove it
    if (Array.isArray(newCut) && newCut.includes('ID')) {
      activeFilters.cut = newCut.filter(v => v !== 'ID');
    }
  } else {
    // Restore all cut options for lab diamonds
    filters.cut.values = { ...DEFAULT_CUT_VALUES };
  }
}, { immediate: true });

const applyCertificatedDiamondFilters = (cd: any) => {
  // Reset limitations
  filters.size.min = 0.3;
  filters.size.max = 10;
  filters.form.values = { ...DEFAULT_FORM_VALUES };

  if (cd.current) {
    if (cd.current.quality) {
      let form = "BR"
      if (formMap[cd.current.form]) {
        form = formMap[cd.current.form];
      }

      const preset = presets.find((p: any) => p.qualityKey === cd.current.quality && p.forms.includes(form));
      if (preset) {
        Object.assign(activeFilters, JSON.parse(JSON.stringify(preset.filters)));
      }
    }
    if (cd.current.size) {

      activeFilters.size = {
        ...activeFilters.size,
        min: Number(cd.current.size) > 0.3 ? Number(cd.current.size) : 0.3
      };
    }
    if (cd.current.form) {
      if (formMap[cd.current.form]) {
        activeFilters.form = formMap[cd.current.form];
      }
    }
    if (cd.current.type) {
      activeFilters.type = cd.current.type;
    }
  }

  if (cd.limits) {
    if (cd.limits.size) {
      if (cd.limits.size.min !== undefined) {
        filters.size.min = Number(cd.limits.size.min) > 0.3 ? Number(cd.limits.size.min) : 0.3;
        if (activeFilters.size.min < filters.size.min) {
          activeFilters.size.min = filters.size.min;
        }
      }
      if (cd.limits.size.max !== undefined) {
        filters.size.max = cd.limits.size.max;
        if (activeFilters.size.max > filters.size.max) {
          activeFilters.size.max = filters.size.max;
        }
      }
    }
    if (cd.limits.form && cd.limits.form.allowed) {
      const allowedForms = cd.limits.form.allowed.map((f: string) => formMap[f]).filter((f: string) => f);
      if (allowedForms.length > 0) {
        const newValues: Record<string, string> = {};
        Object.keys(DEFAULT_FORM_VALUES).forEach((f: string) => {
          if (allowedForms.includes(f)) {
            newValues[f] = (DEFAULT_FORM_VALUES as any)[f];
          }
        });
        filters.form.values = newValues;

        if (activeFilters.form && !allowedForms.includes(activeFilters.form)) {
          activeFilters.form = Object.keys(newValues)[0];
        }
      }
    }
  }
  updateUrl();
};

watch(() => props.certificatedDiamond, (newVal) => {
  if (newVal) {
    applyCertificatedDiamondFilters(newVal);
  }
}, { immediate: true });

const serializeFilters = (filtersToSerialize) => {
  const sortedKeys = Object.keys(filtersToSerialize).sort();
  const parts = [];
  sortedKeys.forEach(key => {
    const val = filtersToSerialize[key];
    if (val === null || val === undefined) return;
    
    let valStr = '';
    if (Array.isArray(val)) {
      if (val.length === 0) return;
      valStr = val.join(',');
    } else if (typeof val === 'object') {
      const subParts = [];
      Object.keys(val).sort().forEach(subKey => {
        subParts.push(`${subKey}:${val[subKey]}`);
      });
      valStr = subParts.join(',');
    } else {
      valStr = val.toString();
    }
    parts.push(`${key}-${valStr}`);
  });
  return parts.join('_');
};

const deserializeFilters = (filterStr) => {
  const result = {};
  if (!filterStr) return result;
  
  const parts = filterStr.split('_');
  parts.forEach(part => {
    const [key, valStr] = part.split('-');
    if (!key || valStr === undefined) return;
    
    const filterDef = filters[key];
    const isArrayDefault = filterDef && Array.isArray(filterDef.default);
    
    if (valStr.includes(':')) {
      const obj = {};
      valStr.split(',').forEach(subPart => {
        const [subKey, subVal] = subPart.split(':');
        if (subKey && subVal !== undefined) {
          obj[subKey] = isNaN(subVal) ? subVal : Number(subVal);
        }
      });
      result[key] = obj;
    } else if (valStr.includes(',')) {
      result[key] = valStr.split(',');
    } else {
      let val;
      if (valStr === 'true') val = true;
      else if (valStr === 'false') val = false;
      else if (valStr !== '' && !isNaN(valStr)) val = Number(valStr);
      else val = valStr;

      if (isArrayDefault) {
        result[key] = val === '' ? [] : [val];
      } else {
        result[key] = val;
      }
    }
  });
  return result;
};

const updateUrl = () => {
  const filterStr = serializeFilters(activeFilters);
  const basePath = setWidgetApi.createPath("diamondSearch");
  const newPath = `${basePath}${filterStr}`;
  window.history.pushState({}, '', newPath);
  localStorage.setItem('lastDiamondSearch', newPath);
};

const updateFiltersFromUrl = () => {
  const path = window.location.pathname;
  const match = path.match(/\/diamonds\/search\/(.*)/);
  if (match && match[1]) {
    const deserialized = deserializeFilters(match[1].replace("/", ""));
    // Reset to defaults first to handle removed filters in URL
    Object.keys(filters).forEach((key) => {
      activeFilters[key] = filters[key].default || null;
    });
    Object.assign(activeFilters, deserialized);
  }
};

onMounted(() => {
  updateFiltersFromUrl();
  window.addEventListener('popstate', updateFiltersFromUrl);
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('popstate', updateFiltersFromUrl);
  window.removeEventListener('resize', checkMobile);
});

const handleFilterUpdate = (newFilters) => {
  if (!newFilters || typeof newFilters !== 'object') return;
  Object.assign(activeFilters, newFilters);
  updateUrl();
};

const buildDefaultFilters = () => {
  const result: Record<string, any> = {};
  Object.keys(filters).forEach((key) => {
    result[key] = (filters as any)[key]?.default ?? null;
  });
  return result;
};

const resetFilters = () => {
  const defaults = buildDefaultFilters();
  handleFilterUpdate(defaults);
};

const mobileSearchFormRef = ref(null);

const scrollToFilter = (key: string) => {
  const el = mobileSearchFormRef.value?.indicatorRefs?.[key];
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const isFilterActive = (key: string) => {
  const filter = filters[key];
  const active = activeFilters[key];
  if (!active) return false;
  if (typeof active === 'object' && filter.default && typeof filter.default === 'object') {
    return active.min !== filter.default.min || active.max !== filter.default.max;
  }
  if (Array.isArray(active) && Array.isArray(filter.default)) {
    return active.length !== filter.default.length || !active.every((v, i) => v === filter.default[i]);
  }
  if (filter.default && active === filter.default) return false;
  return true;
};

const headline = computed(() => {
  if (activeFilters.type === 'lab' && activeFilters.colored === true) {
    return t('components.diamonds.search.headlines.colored_lab');
  } else if (activeFilters.type === 'lab') {
    return t('components.diamonds.search.headlines.lab');
  } else {
    return t('components.diamonds.search.headlines.natural');
  }
});

const getFilterLabel = (key: string) => {
  return t('components.diamonds.search.labels.' + key);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createBlock(DiamondNav, {
          key: 0,
          title: headline.value,
          "show-back": false,
          class: "w-full"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (isMobile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", { class: "fixed bottom-6 left-1/2 -translate-x-1/2 z-40" }, [
            _createElementVNode("button", {
              onClick: toggleMobileFilters,
              class: "bg-[#a99d8b] text-white px-8 py-3 rounded-full shadow-2xl flex items-center gap-2 uppercase tracking-[0.2em] text-sm font-medium hover:bg-[#968977] transition-all active:scale-95"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
                  "clip-rule": "evenodd"
                })
              ], -1),
              _createTextVNode(" Filter ", -1)
            ]))])
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "fixed inset-0 bg-black/40 backdrop-blur-sm z-50 lg:hidden",
                onClick: toggleMobileFilters
              }, null, 512), [
                [_vShow, showMobileFilters.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "slide-up" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-12 h-1.5 bg-gray-200 rounded-full mb-6 mt-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedFilterKeys.value, (key) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: 'indicator-' + key,
                          onClick: ($event: any) => (scrollToFilter(key)),
                          class: _normalizeClass(["whitespace-nowrap px-4 py-1.5 rounded-full text-[11px] uppercase tracking-wider transition-all border", isFilterActive(key) ? 'bg-[#a99d8b] text-white border-[#a99d8b]' : 'bg-gray-50 text-gray-500 border-gray-100'])
                        }, _toDisplayString(getFilterLabel(key)), 11, _hoisted_7))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(DiamondsMobileSearchForm, {
                    ref_key: "mobileSearchFormRef",
                    ref: mobileSearchFormRef,
                    "search-mode": searchMode.value,
                    "onUpdate:searchMode": _cache[0] || (_cache[0] = ($event: any) => ((searchMode).value = $event)),
                    filters: filters,
                    "active-filters": activeFilters,
                    presets: _unref(presets),
                    "onUpdate:filters": handleFilterUpdate
                  }, null, 8, ["search-mode", "filters", "active-filters", "presets"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: toggleMobileFilters,
                    class: "w-full max-w-xs bg-[#a99d8b] text-white py-4 rounded-xl uppercase tracking-[0.2em] text-sm font-bold shadow-lg shadow-[#a99d8b]/20 active:scale-[0.98] transition-all"
                  }, _toDisplayString(_unref(t)('components.catalog.filterSideBar.cta.showResults')), 1),
                  _createElementVNode("button", {
                    onClick: resetFilters,
                    class: "text-xs uppercase tracking-widest text-gray-500 hover:text-gray-900 transition-colors"
                  }, _toDisplayString(_unref(t)('components.catalog.filterSideBar.cta.reset')), 1)
                ])
              ], 512), [
                [_vShow, showMobileFilters.value]
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(DiamondsSearchResult, {
        class: "sticky md:w-2/3 md:max-w-2/3 top-0 h-fit grow",
        "active-filters": activeFilters
      }, null, 8, ["active-filters"]),
      (!isMobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (headline.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("h1", _hoisted_13, _toDisplayString(headline.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(DiamondsSearchForm, {
              "search-mode": searchMode.value,
              "onUpdate:searchMode": _cache[1] || (_cache[1] = ($event: any) => ((searchMode).value = $event)),
              filters: filters,
              "active-filters": activeFilters,
              "onUpdate:filters": handleFilterUpdate
            }, null, 8, ["search-mode", "filters", "active-filters"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})